// import { Tabs, TabsProps } from 'antd';
import styled from 'styled-components';
import Fee from './Fee';
// import Payment from './Payment';

// const CREDIT_CARD_CONFIG_KEYS = {
//   FEE: 'fee',
//   PAYMENT: 'payment',
// };

// const items: TabsProps['items'] = [
//   {
//     key: CREDIT_CARD_CONFIG_KEYS.FEE,
//     label: 'Config Fee',
//     children: <Fee />,
//   },
//   {
//     key: CREDIT_CARD_CONFIG_KEYS.PAYMENT,
//     label: 'Payment',
//     children: <Payment />,
//   },
// ];

const CreditCard = () => {
  return (
    <Fee />
  );
};

export default CreditCard;

// const TabContainer = styled.div`
//   width: 100%;
//   height: 100%;
//   background: #fff;
//   display: flex;
//   flex-direction: column;
//   overflow: hidden;
// `;

// const StyledTabs = styled(Tabs)`
//   width: 100%;
//   height: 100%;

//   .ant-tabs-tab {
//     height: 80px;
//     display: flex;
//     align-items: center;
//     justify-content: center;
//   }

//   .ant-tabs-tab-btn {
//     font-weight: 600;
//     font-size: 24px;
//     font-family: Poppins;
//     color: #505050;
//   }

//   .ant-tabs-tab-active .ant-tabs-tab-btn {
//     color: #2d6772 !important;
//   }

//   .ant-tabs-ink-bar {
//     background: #2d6772;
//     height: 2px;
//   }
// `;
